webpackJsonp([77130807457942],{

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PatternConstruction = __webpack_require__(22);
	
	var _PatternConstruction2 = _interopRequireDefault(_PatternConstruction);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _FormsPatternTutorialBranch = __webpack_require__(41);
	
	var _FormsPatternTutorialBranch2 = _interopRequireDefault(_FormsPatternTutorialBranch);
	
	var _createTweetDialog = __webpack_require__(52);
	
	var _createTweetDialog2 = _interopRequireDefault(_createTweetDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _PatternConstruction2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      '3. Convert Fields to Functions'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'ll be converting our form fields into functions.'
	    ),
	    _react2.default.createElement(_FormsPatternTutorialBranch2.default, { branch: 'create.3' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'What\'s the problem?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To illustrate the issue, take a look at the text field for the form, show below:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      <Field name="text" data={form.data} errors={form.errors} onChange={form.onChange}>\n        {(field) => {\n          return (\n            <div className={`form-group ${field.touched && field.error ? \'has-error\' : \'\'}`}>\n              <label>\n                Message\n              </label>\n              <textarea\n                className="form-control"\n                rows="3"\n                value={field.value}\n                placeholder="What\'s happening?"\n                onChange={(event) => {\n                  field.onChange(event, event.target.value)\n                }}\n                onBlur={field.onBlur}\n              />\n              {field.touched && field.error ? (\n                <span className="help-block">\n                  {field.error}\n                </span>\n              ) : null}\n            </div>\n          )\n        }}\n      </Field>\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Most of this form field will be identical across all forms in the application, which includes the classes applied, where the error message appears, even the callback functions like ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'onChange'
	      ),
	      ' and ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'onBlur()'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In fact, there is very little that\'s unique about this specific text field aside from the field ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'name'
	      ),
	      ', the ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'label'
	      ),
	      ' and the ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'placeholder'
	      ),
	      ' text.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'How do we solve this?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To solve this, we\'re going to convert out form fields into functions, and only provide the information that is truly unique to that field.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'We\'re also going to store these functions in our application configuration, under ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'config/dialogs.js'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Create Config for Dialogs'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Start by creating a new config file called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'dialogs.js'
	      ),
	      ' located at ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'config/dialogs.js'
	      ),
	      ', and paste the code below into that file:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import React from \'react\';\n      import _ from \'lodash\';\n      import { Connect } from \'lore-hook-connect\';\n      import { Field } from \'lore-react-forms\';\n\n      export default {\n\n        fieldMap: {\n          text: function(form, props, name) {\n            const {\n              label,\n              placeholder\n            } = props;\n\n            return (\n              <Field key={name} name={name} data={form.data} errors={form.errors} onChange={form.onChange}>\n                {(field) => {\n                  return (\n                    <div key={name} className={`form-group ${field.touched && field.error ? \'has-error\' : \'\'}`}>\n                      <label>\n                        {label}\n                      </label>\n                      <textarea\n                        className="form-control"\n                        rows="3"\n                        value={field.value}\n                        placeholder={placeholder}\n                        onChange={(event) => {\n                          field.onChange(event, event.target.value)\n                        }}\n                        onBlur={field.onBlur}\n                      />\n                      {field.touched && field.error ? (\n                        <span className="help-block">\n                      {field.error}\n                    </span>\n                      ) : null}\n                    </div>\n                  )\n                }}\n              </Field>\n            );\n          },\n\n          select: function(form, props, name) {\n            const {\n              options,\n              label,\n              optionLabel\n            } = props;\n\n            return (\n              <Field key={name} name={name} data={form.data} errors={form.errors} onChange={form.onChange}>\n                {(field) => {\n                  return (\n                    <div className={`form-group ${field.touched && field.error ? \'has-error\' : \'\'}`}>\n                      <label>\n                        {label}\n                      </label>\n                      <Connect callback={(getState, props) => {\n                        return {\n                          options: _.isFunction(options) ? options(getState, props) : options\n                        };\n                      }}>\n                        {(connect) => {\n                          return (\n                            <select\n                              className="form-control"\n                              value={field.value}\n                              onChange={(event) => {\n                                const value = event.target.value;\n                                field.onBlur();\n                                field.onChange(event, value ? Number(value) : undefined)\n                              }}\n                            >\n                              {[<option key="" value=""/>].concat(connect.options.data.map((datum) => {\n                                return (\n                                  <option key={datum.id} value={datum.id}>\n                                    {_.isFunction(optionLabel) ? optionLabel(datum) : datum.data[optionLabel]}\n                                  </option>\n                                );\n                              }))}\n                            </select>\n                          )\n                        }}\n                      </Connect>\n                      {field.touched && field.error ? (\n                        <span className="help-block">\n                      {field.error}\n                    </span>\n                      ) : null}\n                    </div>\n                  );\n                }}\n              </Field>\n            );\n          }\n        }\n\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The code above defines a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'fieldMap'
	      ),
	      ', which is an map that, when given a name like ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'text'
	      ),
	      ' or ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'select'
	      ),
	      ' will return a function that can generate that type of field.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Each function has an identical signature. The first argument is the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'form'
	      ),
	      ', the second is the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'props'
	      ),
	      ' unique to that field (like label and placeholder text) and the third is the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'name'
	      ),
	      ' of the field.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Why functions?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You could argue that instead of creating a function, we could just create a component, and you\'d be right. But as you\'ll see in later steps, the ultimate goal is to actually create an interface that allows us to ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'describe'
	      ),
	      ' what kind of form we need, instead of constructing it ourselves. And for that, we need to use functions instead of components.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Refactor Fields to Functions'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'With our ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'fieldMap'
	      ),
	      ' created, let\'s use it in our form to replace our current fields. Update the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'render()'
	      ),
	      ' function to look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // src/dialogs/tweet/create/index.js\n      render() {\n        const { data } = this.state;\n        const validators = this.getValidators(data);\n        const { fieldMap } = lore.config.dialogs;\n\n        return (\n          <div className="modal-dialog">\n            <div className="modal-content">\n              <div className="modal-header">\n                ...\n              </div>\n              <Form\n                data={data}\n                validators={validators}\n                onChange={this.onChange}\n                callbacks={{\n                  onSubmit: this.onSubmit,\n                  dismiss: this.dismiss\n                }}\n              >\n                {(form) => (\n                  <PropBarrier>\n                    <div className="modal-body">\n                      <div className="row">\n                        <div className="col-md-12">\n                          {fieldMap[\'text\'](form, {\n                            label: \'Message\',\n                            placeholder: "What\'s happening?"\n                          }, \'text\')}\n                        </div>\n                      </div>\n                      <div className="row">\n                        <div className="col-md-12">\n                          {fieldMap[\'select\'](form, {\n                            label: \'User\',\n                            options: function(getState) {\n                              return getState(\'user.find\');\n                            },\n                            optionLabel: \'nickname\'\n                          }, \'userId\')}\n                        </div>\n                      </div>\n                    </div>\n                    <div className="modal-footer">\n                      ...\n                    </div>\n                  </PropBarrier>\n                )}\n              </Form>\n            </div>\n          </div>\n        );\n      }\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Review'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'With these changes in place, we\'ve removed ~60 lines of code from our form, and created an interface that makes is much more obvious what is unique about each field.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If everything went well, clicking the create button will now launch a dialog that you can use to create a new tweet.'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _createTweetDialog2.default }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Code Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Below is a list of files modified during this step.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'config/dialogs.js'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import React from \'react\';\n      import _ from \'lodash\';\n      import { Connect } from \'lore-hook-connect\';\n      import { Field } from \'lore-react-forms\';\n\n      export default {\n\n        fieldMap: {\n          text: function(form, props, name) {\n            const {\n              label,\n              placeholder\n            } = props;\n\n            return (\n              <Field key={name} name={name} data={form.data} errors={form.errors} onChange={form.onChange}>\n                {(field) => {\n                  return (\n                    <div key={name} className={`form-group ${field.touched && field.error ? \'has-error\' : \'\'}`}>\n                      <label>\n                        {label}\n                      </label>\n                      <textarea\n                        className="form-control"\n                        rows="3"\n                        value={field.value}\n                        placeholder={placeholder}\n                        onChange={(event) => {\n                          field.onChange(event, event.target.value)\n                        }}\n                        onBlur={field.onBlur}\n                      />\n                      {field.touched && field.error ? (\n                        <span className="help-block">\n                      {field.error}\n                    </span>\n                      ) : null}\n                    </div>\n                  )\n                }}\n              </Field>\n            );\n          },\n\n          select: function(form, props, name) {\n            const {\n              options,\n              label,\n              optionLabel\n            } = props;\n\n            return (\n              <Field key={name} name={name} data={form.data} errors={form.errors} onChange={form.onChange}>\n                {(field) => {\n                  return (\n                    <div className={`form-group ${field.touched && field.error ? \'has-error\' : \'\'}`}>\n                      <label>\n                        {label}\n                      </label>\n                      <Connect callback={(getState, props) => {\n                        return {\n                          options: _.isFunction(options) ? options(getState, props) : options\n                        };\n                      }}>\n                        {(connect) => {\n                          return (\n                            <select\n                              className="form-control"\n                              value={field.value}\n                              onChange={(event) => {\n                                const value = event.target.value;\n                                field.onBlur();\n                                field.onChange(event, value ? Number(value) : undefined)\n                              }}\n                            >\n                              {[<option key="" value=""/>].concat(connect.options.data.map((datum) => {\n                                return (\n                                  <option key={datum.id} value={datum.id}>\n                                    {_.isFunction(optionLabel) ? optionLabel(datum) : datum.data[optionLabel]}\n                                  </option>\n                                );\n                              }))}\n                            </select>\n                          )\n                        }}\n                      </Connect>\n                      {field.touched && field.error ? (\n                        <span className="help-block">\n                      {field.error}\n                    </span>\n                      ) : null}\n                    </div>\n                  );\n                }}\n              </Field>\n            );\n          }\n        }\n\n      }\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/dialogs/tweet/create/index.js'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import React from \'react\';\n      import createReactClass from \'create-react-class\';\n      import PropTypes from \'prop-types\';\n      import _ from \'lodash\';\n      import { Form, PropBarrier } from \'lore-react-forms\';\n\n      export default createReactClass({\n        displayName: \'CreateTweetDialog\',\n\n        propTypes: {\n          onCancel: PropTypes.func\n        },\n\n        getInitialState() {\n          return {\n            data: {\n              text: \'\',\n              userId: undefined\n            }\n          };\n        },\n\n        request(data) {\n          lore.actions.tweet.create(data);\n        },\n\n        onSubmit() {\n          const { data } = this.state;\n          this.request(data);\n          this.dismiss();\n        },\n\n        dismiss() {\n          this.props.onCancel();\n        },\n\n        onChange(name, value) {\n          const nextData = _.merge({}, this.state.data);\n          nextData[name] = value;\n          this.setState({\n            data: nextData\n          });\n        },\n\n        getValidators: function(data) {\n          return {\n            text: [function(value) {\n              if (!value) {\n                return \'This field is required\';\n              }\n            }],\n            userId: [function(value) {\n              if (value === undefined) {\n                return \'This field is required\'\n              }\n            }]\n          };\n        },\n\n        render() {\n          const { data } = this.state;\n          const validators = this.getValidators(data);\n          const { fieldMap } = lore.config.dialogs;\n\n          return (\n            <div className="modal-dialog">\n              <div className="modal-content">\n                <div className="modal-header">\n                  <button type="button" className="close" onClick={this.dismiss}>\n                    <span>&times;</span>\n                  </button>\n                  <h4 className="modal-title">\n                    Create Tweet\n                  </h4>\n                </div>\n                <Form\n                  data={data}\n                  validators={validators}\n                  onChange={this.onChange}\n                  callbacks={{\n                    onSubmit: this.onSubmit,\n                    dismiss: this.dismiss\n                  }}\n                >\n                  {(form) => (\n                    <PropBarrier>\n                      <div className="modal-body">\n                        <div className="row">\n                          <div className="col-md-12">\n                            {fieldMap[\'text\'](form, {\n                              label: \'Message\',\n                              placeholder: "What\'s happening?"\n                            }, \'text\')}\n                          </div>\n                        </div>\n                        <div className="row">\n                          <div className="col-md-12">\n                            {fieldMap[\'select\'](form, {\n                              label: \'User\',\n                              options: function(getState) {\n                              return getState(\'user.find\');\n                            },\n                              optionLabel: \'nickname\'\n                            }, \'userId\')}\n                          </div>\n                        </div>\n                      </div>\n                      <div className="modal-footer">\n                        <div className="row">\n                          <div className="col-md-12">\n                            <button\n                              type="button"\n                              className="btn btn-default"\n                              onClick={form.callbacks.dismiss}\n                            >\n                              Cancel\n                            </button>\n                            <button\n                              type="button"\n                              className="btn btn-primary"\n                              disabled={form.hasError}\n                              onClick={form.callbacks.onSubmit}\n                            >\n                              Create\n                            </button>\n                          </div>\n                        </div>\n                      </div>\n                    </PropBarrier>\n                  )}\n                </Form>\n              </div>\n            </div>\n          );\n        }\n\n      });\n      ' }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we\'re going to ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../step-4/' },
	        'convert the actions to functions'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-forms-pattern-create-step-3-js-ec0580cf249c0b8b6e24.js